export default __webpack_public_path__ + "static/media/clockwise.90260aee.svg";